function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 3
}, React.createElement("path", {
  d: "M364 2v102.906h198",
  strokeDasharray: "0 12"
}), React.createElement("path", {
  d: "M364 494V386.86h261.633V274H2v-87.992h181.766V2",
  strokeDasharray: "2 12"
}));

function SvgCtaDotsBg(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 628 496"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjI4IDQ5NiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2Utd2lkdGg9IjMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIgMikiPjxwYXRoIGQ9Im0zNjIgMHYxMDIuOTA2MjVoMTk4IiBzdHJva2UtZGFzaGFycmF5PSIwIDEyIi8+PHBhdGggZD0ibTM2MiA0OTJ2LTEwNy4xNDA2MjVoMjYxLjYzMjgxMnYtMTEyLjg1OTM3NWMtNDE1Ljc1NTIwOCAwLTYyMy42MzI4MTIgMC02MjMuNjMyODEyIDBzMC0yOS4zMzA3MjkgMC04Ny45OTIxODhoMTgxLjc2NTYyNXYtMTg0LjAwNzgxMiIgc3Ryb2tlLWRhc2hhcnJheT0iMiAxMiIvPjwvZz48L3N2Zz4=";
export { SvgCtaDotsBg as ReactComponent };